module.exports = (__webpack_require__(6))(444);


//////////////////
// WEBPACK FOOTER
// delegated ./src/main/webapp/app/vendor.ts from dll-reference vendor
// module id = 472
// module chunks = 0